if (!customElements.get('bm-search-hint')) {
  customElements.define('bm-search-hint', class extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input');
      this.hint = this.querySelector('.search-hint');
      const template = this.querySelector('template');
      if (!this.input || !this.hint || !template) return;
      this.phrases = template.content.textContent.split(/\r?\n/).map(text => text.trim()).filter(Boolean);
      if (!this.phrases.length) return;
      this.text = this.querySelector('.search-hint__text');
      this.index = 0;
      this.text.textContent = this.phrases[0];
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.refresh = () => {
        clearInterval(this.timer);
        clearTimeout(this.transition);
        this.text.classList.remove('is-leaving', 'is-entering');
        const active = !this.input.value && document.activeElement !== this.input && !this.motion.matches && !document.hidden;
        this.hint.hidden = !active;
        this.classList.toggle('has-search-hint', active);
        if (active && this.phrases.length > 1) {
          this.timer = setInterval(() => this.advance(), Math.max(2000, Number(this.dataset.interval) || 4000));
        }
      };
      ['focus', 'blur', 'input', 'change'].forEach(event => this.input.addEventListener(event, this.refresh, options));
      document.addEventListener('visibilitychange', this.refresh, options);
      this.motion.addEventListener('change', this.refresh, options);
      this.refresh();
    }
    advance() {
      if (this.input.value || document.activeElement === this.input) { this.refresh(); return; }
      this.text.classList.add('is-leaving');
      this.transition = setTimeout(() => {
        this.index = (this.index + 1) % this.phrases.length;
        this.text.textContent = this.phrases[this.index];
        this.text.classList.remove('is-leaving');
        this.text.classList.add('is-entering');
        this.transition = setTimeout(() => this.text.classList.remove('is-entering'), 220);
      }, 180);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      clearTimeout(this.transition);
      this.controller?.abort();
    }
  });
}
